var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "searchCard insightBanner" }, [
    _c("div", { staticClass: "insightBanner__headlineContainer" }, [
      _vm.insight
        ? _c(
            "svg",
            {
              staticClass: "insightBanner__headlineIcon",
              attrs: { height: "24px", width: "24px", "aria-hidden": "true" },
            },
            [_c("use", { attrs: { href: _vm.bannerIcon } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "insightBanner__headline",
          class: !_vm.insight ? "text-upper text-bold" : "",
        },
        [_vm._v(_vm._s(_vm.bannerTitle))]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "insightBanner__content" }, [
      !_vm.insight
        ? _c("span", [
            _vm.bannerInsights.includes("market")
              ? _c("p", { domProps: { innerHTML: _vm._s(_vm.marketOnly) } })
              : _vm.bannerInsights.includes("consumer")
              ? _c("p", { domProps: { innerHTML: _vm._s(_vm.consumerOnly) } })
              : _vm._e(),
          ])
        : _c("div", [
            _vm.urlQuery === ""
              ? _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.bannerContent) +
                      "\n            "
                  ),
                ])
              : _vm.insightResultCounter === 1
              ? _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.bannerContentSingleCount) },
                })
              : _c("p", {
                  domProps: { innerHTML: _vm._s(_vm.bannerContentCount) },
                }),
          ]),
    ]),
    _vm._v(" "),
    _vm.bannerLink
      ? _c("div", { staticClass: "insightBanner__linkContainer" }, [
          _c(
            "button",
            {
              staticClass: "insightBanner__link",
              attrs: { "data-gtm": `insightBanner__${_vm.bannerTitle}` },
              on: {
                click: function ($event) {
                  return _vm.selectContentType([_vm.bannerName])
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.bannerLinkTitle) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "insightBanner__linkIcon",
              attrs: { height: "12px", width: "12px", "aria-hidden": "true" },
            },
            [_c("use", { attrs: { href: "#iconChevronRightBold" } })]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }